import { render, staticRenderFns } from "./ChatterRow.vue?vue&type=template&id=42bd0bd4&scoped=true"
import script from "./ChatterRow.vue?vue&type=script&lang=js"
export * from "./ChatterRow.vue?vue&type=script&lang=js"
import style0 from "./ChatterRow.vue?vue&type=style&index=0&id=42bd0bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd0bd4",
  null
  
)

export default component.exports